module.exports = __webpack_public_path__ + "img/2.f0b71507.png";